import { IStepsHistoryItem } from '../types/internal';
import { EStepCode } from '../../../types/form';

interface IParams {
  stepsHistory: IStepsHistoryItem[];
  stepsToSkip: EStepCode[];
}

interface IReturn {
  prevHistoryItem: IStepsHistoryItem;
  slicedHistory: IStepsHistoryItem[];
}

/**
 * Хелпер возвращает предыдущий шаг из истории шагов
 * Учитывает, что предыдущий шаг может оказаться среди пропущенных
 * Дополнительно возвращает обновленную историю шагов (шаги с конца обрезаются)
 * */
export const getPrevStep = (params: IParams): IReturn | null => {
  const { stepsHistory, stepsToSkip } = params;

  for (let i = stepsHistory.length - 2; i >= 0; i--) {
    if (!stepsToSkip.includes(stepsHistory[i].stepCode)) {
      const prevHistoryItem = stepsHistory[i];
      const slicedHistory = stepsHistory.slice(0, i + 1);

      return { prevHistoryItem, slicedHistory };
    }
  }

  return null;
};
